"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmUserUpdatedV1Schema = void 0;
const zod_1 = require("zod");
const webhook_payloads_1 = require("./webhook-payloads");
const Operation = zod_1.z.enum(['waiting', 'in_review', 'released', 'blocked']);
const BlockOwner = zod_1.z.enum(['vendepay', 'stripe']).nullable();
/** Nova-owned outbound contract. No raw requirements, documents, bank details or provider identifiers. */
exports.CrmUserUpdatedV1Schema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    type: zod_1.z.literal('crm.user.updated'),
    apiVersion: zod_1.z.literal(webhook_payloads_1.WebhookApiVersionV1),
    createdAt: zod_1.z.string().datetime(),
    data: zod_1.z.object({
        asOf: zod_1.z.string().datetime(),
        user: zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string().nullable(), email: zod_1.z.string(), phone: zod_1.z.string().nullable() }).strict(),
        onboarding: zod_1.z.object({
            badge: zod_1.z.enum(['in_progress', 'in_review', 'correction_needed', 'approved']),
            steps: zod_1.z.object({ profile: zod_1.z.enum(['pending', 'in_review', 'fix', 'done']),
                identity: zod_1.z.enum(['unavailable', 'preparing', 'pending', 'in_review', 'fix', 'done']),
                bank: zod_1.z.enum(['unavailable', 'pending', 'fix', 'done']) }).strict(),
            operations: zod_1.z.object({ sales: Operation, payouts: Operation }).strict(),
            blockedBy: zod_1.z.object({ sales: BlockOwner, payouts: BlockOwner }).strict(),
            nextStep: zod_1.z.object({ owner: zod_1.z.enum(['seller', 'stripe', 'support', 'none']),
                code: zod_1.z.enum(['save_profile', 'fix_field', 'identity_document', 'add_bank_account', 'fix_bank_account', 'wait_review', 'rejected', 'activation_failed', 'unsupported_requirement', 'account_disabled', 'sync_failing', 'none']),
                since: zod_1.z.string().optional() }).strict(),
        }).strict(),
        verification: zod_1.z.object({ kycStatus: zod_1.z.enum(['verified', 'pending_verification', 'action_required', 'rejected']), observedAt: zod_1.z.string().nullable(), currentDeadline: zod_1.z.string().nullable() }).strict().nullable(),
    }).strict(),
}).strict();
//# sourceMappingURL=crm-webhook.js.map